import React from "react";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useGAEventsTracker } from "../../util/gtag";

export default function CtaSection(props) {
  const GAEventTrackerGetStarted = useGAEventsTracker(
    window.location.pathname + "/Get Started"
  );
  const history = useHistory();

  const handleGetStart = () => {
    // Get the current URL
    const currentUrl = window.location.pathname;
    // Check if the URL ends with a slash, then append '/questionnaire'
    const newUrl = currentUrl.endsWith("/")
      ? `${currentUrl}questionnaire`
      : `${currentUrl}/questionnaire`;
    // Use pushState to change the URL without reloading the page
    // window.history.pushState(null, "", newUrl);
    history.push(newUrl);
    // props.setCDrawerHome(true);
    // window.location.reload();
  };

  return (
    <>
      <div
        className="col-12 w-100 h-25 d-flex align-items-center justify-content-center py-5"
        style={{
          background:
            "linear-gradient(90.12deg, #315990 5.09%, rgba(255, 255, 255, 0.5) 48.89%, #345B91 99.89%)",
          backgroundImage: "url('/assets/images/cta_section_image.png')",
          backgroundSize: "auto",
        }}
      >
        <div className="text-container-center">
          <h2 className="jost-bold text-center">
            Ready to make your next move easy?
          </h2>
          <div className=" p-0 inter">
            <div className="px-2 py-3">
              <Button
                variant="contained"
                disableelevation="true"
                color="inherit"
                type={props.submitSuccess === true ? "submit" : "button"}
                className="get-started-btn inter"
                style={{
                  height: "54px",
                  color: "white",
                  backgroundColor: `${
                    props.partner.secondary_color
                      ? props.partner.secondary_color
                      : "#2A83C2"
                  }`,
                }}
                onClick={(e) => {
                  GAEventTrackerGetStarted("Get started", 1);
                  handleGetStart();
                }}
                // {...{
                //     "aria-haspopup": "true",
                // }}
              >
                Submit an Application
              </Button>
              <p
                className="text-start py-3 m-0"
                style={{ fontSize: "18px", textAlign: "center" }}
              >
                <sup>*</sup>It's free and only takes 5 minutes!
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
